<template>
    <div>
        <pack
                v-if="what === 'sink'"
        v-bind:content="{packListData: packListData}"
        ></pack>
        <buyers
                v-if="what === 'sink'"
                v-bind:content="{packListData: packListData}"
        ></buyers>
        <div class="col-md-12" v-if="what !== 'sink'">
            <div class="card abtg__default-card abtg__default-card-border">
                <div class="card-head">
                    <header></header>
                </div>
                <div class="card-body ">

                    <div class="row">
                        <div class="col">
                            <h4>Utenti che utilizzano REP</h4>
                            <hr>
                            <p>7 Giorni Free: <strong>{{count7}}</strong> | LifeTime: <strong>{{countLifeTime}}</strong> | Annuale: <strong>{{annualCount}}</strong> | Mensile: <strong>{{monthCount}}</strong></p>
                            <p> Oggi il <strong>{{unusedMap}}</strong> % ha utilizzato la mappa</p>
                        </div>

                    </div>

                    <hr>
                    <div class="row" v-if="userInAssistance">
                        <div class="col-lg-3">
                            <i class="fas fa-ambulance"></i> {{userInAssistance.email}}
                        </div>
                        <div class="col-lg-1">
                            <button class="btn btn-success abtg__btn-star" @click="removeAssistance()">Rimuovi assistenza</button>
                        </div>
                    </div>
                    <hr v-if="userInAssistance">

                    <div class="table-responsive">
                        <table class="mdl-data-table ml-table-striped ml-table-bordered mdl-js-data-table   is-upgraded">
                            <thead>
                            <tr class="d-flex">

                                <th class="text-left col-3 abtg__vertical-align">Pacchetto</th>
                                <th class="text-left  abtg__vertical-align col-3">
                                    Email
                                </th>
                                <th class="text-left abtg__vertical-align col-3">
                                    Expires
                                </th>
                                <th class="text-left abtg__vertical-align col-1">
                                    Map
                                </th>

                                <th class="text-left abtg__vertical-align col-2 ">

                                </th>


                            </tr>
                            </thead>
                            <tbody>
                            <tr class="d-flex" v-for="user in activeUsers">


                                <td class="align-top col-3">



                                    {{user.pack}}
                                </td>
                                <td class="align-top col-3">
                                    {{user.email}}
                                </td>

                                <td class="align-top col-3">
                                    {{user.expired_at}}
                                </td>
                                <td class="align-top col-1">
                                   <span v-if="user.pack === 'Real Estate Pro - Trial 7 giorni'"> {{user.counter_map}}</span>
                                </td>

                                <td class="align-top  col-2 ">

                                    <div class=" text-right" role="group" aria-label="Basic example">
                                        <a @click="activeAssistance(user.id)"

                                        >
                                            <i class="fas fa-ambulance"></i>
                                        </a>&nbsp;&nbsp;



                                        &nbsp;&nbsp;

                                    </div>

                                </td>
                            </tr>
                            </tbody>
                        </table>

                    </div>

                </div>
                <div class="card-footer">
                    <div class="float-right">

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mixin} from '../../helpers/helper'
    import {Money} from 'v-money';
    import {createHelpers} from 'vuex-map-fields';

    import pack from './pack.vue';
    import buyers  from './buyers';

    const {mapFields} = createHelpers({
        getterType: 'coach/getField',
        mutationType: 'coach/updateField',
    });

    export default {
        mixins: [mixin],
        components: {Money, pack, buyers},
        props: ['what'],
        data: function () {
            return {


            }
        },

        computed: {
            ...mapFields(['activeUsers', 'count7', 'countLifeTime', 'unusedMap', 'annualCount', 'monthCount', 'userId', 'userInAssistance',
                'packListData'
            ]),
        },
        created: function () {
            this.$store.dispatch('coach/usersList');
            this.$store.dispatch('coach/packList');
            this.realTimeAssistance();
        },
        methods: {

           activeAssistance: function(id)
           {
               this.userId = id;
               this.$store.dispatch('coach/activeAssistance');

           },

            realTimeAssistance: function()
            {
                this.$store.dispatch('coach/realTimeAssistance');
            },

            removeAssistance: function()
            {
                this.$store.dispatch('coach/removeAssistance');
            }
        }
    }
</script>